import { helpers } from "../util/helpers.ts";

export interface NotableAchievement {
	statName: string;
	statKey: string;
	pid: number;
	name: string;
	abbrev: string;
	tid: number;
	newRank: number;
	oldRank: number;
	newValue: number;
	passedPlayer?: {
		pid: number;
		name: string;
		abbrev: string;
		tid: number;
		value: number;
		rank: number;
	};
}

const NotableAchievements = ({
	achievements,
	title = "Notable Achievements",
}: {
	achievements: NotableAchievement[];
	title?: string;
}) => {
	if (!achievements || achievements.length === 0) {
		return null;
	}

	return (
		<div className="mb-4">
			<h2>{title}</h2>
			<ul className="list-unstyled">
				{achievements.map((ach, idx) => {
					return (
						<li key={idx} className="mb-3">
							<div className="mb-1">
								<b>All-Time {ach.statName}:</b>
							</div>
							<div style={{ paddingLeft: "15px" }}>
								<div className="d-flex align-items-center flex-wrap">
									<span
										className="text-success me-2"
										style={{ fontWeight: "bold" }}
									>
										▲ {ach.newRank}th
									</span>{" "}
									<b>
										<a href={helpers.leagueUrl(["player", ach.pid])}>
											{ach.name}
										</a>
									</b>{" "}
									<span className="text-muted ms-1 me-2">
										(
										<a href={helpers.leagueUrl(["roster", ach.abbrev])}>
											{ach.abbrev}
										</a>
										)
									</span>
									<span className="font-monospace fw-bold">
										{ach.newValue.toLocaleString()}
									</span>
									<span
										className="text-muted ms-2"
										style={{ fontSize: "0.85em" }}
									>
										(moved up from{" "}
										{ach.oldRank === Infinity ? "unranked" : `${ach.oldRank}th`}
										)
									</span>
								</div>
								{ach.passedPlayer && (
									<div
										className="text-muted d-flex align-items-center flex-wrap ps-4"
										style={{ fontSize: "0.9em", marginTop: "2px" }}
									>
										<span className="me-2">{ach.passedPlayer.rank}th</span>
										<a
											href={helpers.leagueUrl(["player", ach.passedPlayer.pid])}
											className="text-muted me-1"
										>
											{ach.passedPlayer.name}
										</a>
										<span className="text-muted me-2">
											({ach.passedPlayer.abbrev})
										</span>
										<span className="font-monospace">
											{ach.passedPlayer.value.toLocaleString()}
										</span>
									</div>
								)}
							</div>
						</li>
					);
				})}
			</ul>
		</div>
	);
};

export default NotableAchievements;
